/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class ModelTargetDialog extends SiteEntityDialog<ModelTargetRow, any> {
        protected getFormKey() { return ModelTargetForm.formKey; }
        protected getIdProperty() { return ModelTargetRow.idProperty; }
        protected getLocalTextPrefix() { return ModelTargetRow.localTextPrefix; }
        protected getNameProperty() { return ModelTargetRow.nameProperty; }
        protected getService() { return ModelTargetService.baseUrl; }

        protected form = new ModelTargetForm(this.idPrefix);

        constructor() {
            super();

            var codes = $();
            for (var i = 1; i <= 10; i++)
                codes = codes.add(this.form["Code" + i].element);
            
            codes.change(() => {
                var level = this.level;
                var path = "";
                for (var l = 1; l <= level; l++) {
                    if (path.length > 0)
                        path += "/";
                    path += this.form["Code" + l].value;
                }
                this.form.TargetCode.value = path;
            });
        }

        protected get level() {
            var level = this.entity.Level;
            if (!level || level < 1)
                level = 1;
            else if (level > 10)
                level = 10;
            return level;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var type = ModelRow.getLookup().itemById[this.entity.ModelCode];

            var level = this.level;
            for (var l = 1; l <= 10; l++) {
                this.byId('Code' + l).closest('.field').toggle(l == level);
                this.byId('Name' + l).closest('.field').toggle(l == level);
                var fullName = this.byId('FullName' + l);
                fullName.val((this.entity['Code' + l] || '') + ' - ' + (this.entity['Name' + l] || ''));
                fullName.closest('.field').toggle(l < level).children('.caption')
                    .text((type && type['LevelName' + l]) || '');
            }

            if (type) {
                var codeField = this.byId('Code' + level).closest('.field');
                var nameField = this.byId('Name' + level).closest('.field');
                codeField.children('.caption').text(type['LevelName' + level] + " Code");
                nameField.children('.caption').text(type['LevelName' + level] + " Name");
                Serenity.EditorUtils.setRequired(this.byId('Code' + level).getWidget(Serenity.Widget), true);
                Serenity.EditorUtils.setRequired(this.byId('Name' + level).getWidget(Serenity.Widget), true);
            }
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.TargetCode.getGridField().toggle(
                this.entity.ModelCode && (ModelRow.getLookup().itemById[this.entity.ModelCode] || {}).Levels > 1);
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            var deleteButton = Q.tryFirst(buttons, x => x.cssClass == "delete-button");
            if (deleteButton)
                deleteButton.onClick = () => {
                    this.doDelete(() => this.dialogClose());
                };

            return buttons;
        }

        private lastDeleteOptions: Serenity.ServiceOptions<Serenity.DeleteResponse>;

        protected deleteHandler(options, callback) {
            this.lastDeleteOptions = options;
            super.deleteHandler(options, callback);
        }

        protected getDeleteOptions(callback) {
            var opt = super.getDeleteOptions(callback);
            var oldError = opt.onError;
            opt.onError = (response) => {
                if (response && response.Error && response.Error.Code == "RequireConfirmation" &&
                    this.lastDeleteOptions && !(this.lastDeleteOptions.request as ModelTargetDeleteRequest).ConfirmDelete) {

                    Q.confirm(response.Error.Message, () => {
                        (this.lastDeleteOptions.request as ModelTargetDeleteRequest).ConfirmDelete = true;
                        this.deleteHandler(this.lastDeleteOptions, callback);
                    });

                    return;
                }

                if (oldError)
                    oldError(response);
                else
                    Q.ErrorHandling.showServiceError(response.Error);
            };
            
            return opt;
        }
    }
}